import { demoAccount } from "../../app/container/apollo-client/demo-data";
import { FewAccountDetailsDocument } from "../../app/types/generated/graphql";

export const mockFewAccountDetails = {
  request: {
    query: FewAccountDetailsDocument,
  },
  result: {
    data: {
      account: {
        id: demoAccount.id,
        tenantId: demoAccount.tenantId,
        termsAcceptedDate: demoAccount.termsAcceptedDate,
        rulesAcceptedDate: demoAccount.rulesAcceptedDate,
        privacyPolicyAcceptedDate: demoAccount.privacyPolicyAcceptedDate,
        status: demoAccount.status,
        firstName: demoAccount.firstName,
        lastName: demoAccount.lastName,
        email: demoAccount.email,
        linkedRegistries: demoAccount.linkedRegistries,
      },
    },
  },
};
